import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const bulkOperationsConnectionsSubscriberEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-bulk-operations-connections-subscriber" */ './ui'),
	),
	getPreloadProps: () => ({}),
});
